// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2s9_x","rootSuccess":"CompleteLink_rootSuccess__4ROOQ","rootFailure":"CompleteLink_rootFailure__18abk","isDisabled":"CompleteLink_isDisabled__1Vmd1"};